import { ModelBase } from 'store/model-base';

export class CmsInternationalTravel extends ModelBase {
    public static storeName: string = 'cmsInternationalTravel';

    public title: string;
    public subtitle: string;
    public gtpIcon: CmsMediaImage;
    public inUseIcon: CmsMediaImage;
    public featuresTitle: string;
    public cardTitle: string;
    public gtpContent: GtpContent[];
    public gtpContentEnhancement: GtpContent[];
    public supportHeader: string;
    public supportLinks: CmsGtpSupportLink[];
    public roamingDisabled: CmsRoamingDisabled;
    public gtpPassPrice: string;
}
